class TestimonialsCarousel extends HTMLElement {
  connectedCallback() {
    // Get elements
    this.grid = this.querySelector('.testimonials-slider__grid');
    if (!this.grid) {
      return;
    }

    // Get settings
    const autoplay = this.dataset.autoplay === 'true';
    const speed = parseInt(this.dataset.speed) || 30;
    
    if (!autoplay) {
      return;
    }

    // Get original items
    const items = [...this.querySelectorAll('.testimonials-slider__item:not(.cloned)')];
    
    if (items.length < 2) {
      return;
    }

    // MEASURE WIDTH FIRST, before cloning
    setTimeout(() => {
      // Clone items
      const fragment = document.createDocumentFragment();
      for (let i = 0; i < 2; i++) {
        items.forEach(item => {
          const clone = item.cloneNode(true);
          clone.classList.add('cloned');
          fragment.appendChild(clone);
        });
      }
      this.grid.appendChild(fragment);
      
      // Wait for layout, then measure the ACTUAL position of the first clone
      setTimeout(() => {
        // Reset scroll to 0 for accurate measurement
        this.grid.scrollLeft = 0;
        
        // Find the first cloned item
        const firstClone = this.grid.querySelector('.cloned');
        if (firstClone) {
          // Measure using offsetLeft which gives position within the scroll container
          this.oneSetWidth = firstClone.offsetLeft;
        }
        
        this.startScrolling(speed);
      }, 100);
      
    }, 200);
  }

  startScrolling(speed) {
    const isMobile = window.innerWidth <= 768;
    const speedMultiplier = isMobile ? 2 : 1;
    const visualSpeed = speed / 3;
    const adjustedSpeed = visualSpeed / speedMultiplier;
    const pixelsPerSecond = this.oneSetWidth / adjustedSpeed;
    const pixelsPerFrame = pixelsPerSecond / 60;

    let isPaused = false;

    // Desktop: pause on hover
    this.grid.addEventListener('mouseenter', () => {
      isPaused = true;
    });
    this.grid.addEventListener('mouseleave', () => { 
      isPaused = false;
    });

    // Mobile: pause on touch
    this.grid.addEventListener('touchstart', () => {
      isPaused = true;
    }, { passive: true });
    
    this.grid.addEventListener('touchend', () => {
      setTimeout(() => {
        isPaused = false;
      }, 1000);
    }, { passive: true });

    // Animation loop
    const scroll = () => {
      if (!isPaused) {
        // Check if we need to reset BEFORE incrementing
        // Reset when we're very close to or past the reset point
        if (this.grid.scrollLeft >= this.oneSetWidth - pixelsPerFrame) {
          const newPosition = this.grid.scrollLeft - this.oneSetWidth;
          this.grid.scrollLeft = newPosition;
        }
        
        // Now increment
        this.grid.scrollLeft += pixelsPerFrame;
      }
      
      requestAnimationFrame(scroll);
    };

    requestAnimationFrame(scroll);
  }
}

customElements.define('testimonials-carousel', TestimonialsCarousel);
